import React from 'react'
import { Spinner } from 'lib/ui/components'
import { Breadcrumbs } from 'components/Breadcrumbs'
import { useOrderReturns } from 'hooks/returns'
import { OrdersForm } from './scenes/OrdersForm'
import { Navbar } from './components/Navbar'
import { Container } from './styled'

export const OrdersAndReturns = () => {
  const { getOrderData, rmaOrderData, orderDataLoading, creatingOrder } = useOrderReturns()
  const isLoading = orderDataLoading || creatingOrder
  return (
    <Container>
      <Breadcrumbs
        title='Order Information'
      />
      {isLoading && (
        <div className='overlay'>
          <Spinner />
        </div>
      )}
      <Navbar data={rmaOrderData} />
      {/* Temporary disabling
      <Switch>
        <Route path='/sales/guest/form'>
          <OrdersForm setOrderInfo={getOrderData} />
        </Route>

        <Route path='/sales/guest/view'>
          <OrderInformation data={rmaOrderData} />
        </Route>

        <Route exact path='/sales/guest/create-return'>
          <CreateReturn
            data={rmaOrderData}
            onSubmit={createReturn}
            orderInfo={orderInfo}
          />
        </Route>

        <Redirect
          to='/sales/guest/form'
        />
      </Switch> */}
      <OrdersForm setOrderInfo={getOrderData} />
    </Container>
  )
}
